import type { ApiClient } from '../../../shared/api/api-client';
import type {
  OrgDashboardWarningItem,
  OrgDashboardWarningSeverity,
  OrgDashboardWarningsResponse
} from './org-dashboard-warnings.types';

const SEVERITIES: ReadonlySet<string> = new Set(['warning', 'danger', 'info']);

function parseSeverity(v: unknown): OrgDashboardWarningSeverity {
  return typeof v === 'string' && SEVERITIES.has(v) ? (v as OrgDashboardWarningSeverity) : 'warning';
}

function parseWarningRow(row: unknown): OrgDashboardWarningItem | null {
  if (!row || typeof row !== 'object') return null;
  const o = row as Record<string, unknown>;
  const code = typeof o.code === 'string' ? o.code.trim() : '';
  const title = typeof o.title === 'string' ? o.title.trim() : '';
  const detail = typeof o.detail === 'string' ? o.detail.trim() : '';
  if (!code || !title) return null;
  return {
    code,
    severity: parseSeverity(o.severity),
    title,
    detail
  };
}

/** GET `/organizations/me/dashboard-warnings` — операционные предупреждения org-дашборда (не платформенный дашборд). */
export async function fetchOrgDashboardWarnings(client: ApiClient): Promise<OrgDashboardWarningsResponse> {
  const raw = await client.request<unknown>('/organizations/me/dashboard-warnings', { method: 'GET' });
  if (!raw || typeof raw !== 'object') return { warnings: [] };
  const o = raw as Record<string, unknown>;
  const list = Array.isArray(o.warnings) ? o.warnings : [];
  const warnings: OrgDashboardWarningItem[] = [];
  for (const row of list) {
    const item = parseWarningRow(row);
    if (item) warnings.push(item);
  }
  return { warnings };
}
